import $ from 'jquery';
import 'bootstrap/js/dist/modal';
import axios from "axios";
import {makeFormData} from "../general-form-maker";
import {renderErrorByResponse} from '../render-response';
import {renderPasswordRecoverModal} from "../info/render-password-recover-modal";
import {AUTH_RESET_PASSWORD} from "Core/links";

let isPressedBtn = false;

export const bindEventsToModalForgotPassword = () => {
    $('#forgot-password-button').click(function () {
        const parent = $(this).parents('.modal-form');

        if (!isPressedBtn) {
            isPressedBtn = true;
            axios.post(AUTH_RESET_PASSWORD, makeFormData(parent))
                .then((response) => {
                    renderPasswordRecoverModal();
                })
                .catch((error) => {
                    isPressedBtn = false;
                    renderErrorByResponse(error.response, parent);
                });
        }
    });
};
